export default "__VITE_ASSET__MYIx_qa9__"